export const trustBadges = {
  neasc: "Acreditado NEASC",
  xunta: "Autorizada pela Xunta da Galicia",
  trilingual: "Inglês 40-50% | ES | GL",
  ages: "3-12 anos · Turmas reduzidas"
};
